import { ActivatedRouteSnapshot } from '@angular/router';
import { RouterStateSnapshot } from '@angular/router';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable ,  Subscription } from 'rxjs';

import { AuthService } from './auth.service';
import { tap, first } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate, OnDestroy {

    private _isAuthSubscription: Subscription;

    constructor(private _authService: AuthService, private _router: Router) {
        this.subscribeOnAuthChanged();
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this._authService.isAuth.pipe(first());
    }

    subscribeOnAuthChanged(): void {
        this._isAuthSubscription = this._authService
            .isAuth
            .pipe(
                tap(isAuth => {
                    if (!isAuth) {
                        const url = this._router.routerState.snapshot.url.split('returnUrl=');
                        const returnUrl = url.length > 1 ? url[1] : url [0];
                        this._router.navigate(['/login'], { queryParams: { returnUrl: returnUrl } });
                    }
                })
            )
            .subscribe();
    }

    ngOnDestroy() {
        this._isAuthSubscription.unsubscribe();
    }
}
